// extracted by mini-css-extract-plugin
export default {"CrbWidget":"CrbWidget_CrbWidget__fwama","CrbContent":"CrbWidget_CrbContent__momAo","CrbImg":"CrbWidget_CrbImg__2UEBg"};